import { Box } from "@mui/system";
import AirlineIcon from "./AirlineIcon";
import { FlightSearchResult } from "@/core/types/types";
import { IFormatedFlightData } from "./FlightsSelect";
import { RadioButtonGroupItem } from "@flightright/reusable-components";

interface CustomizedFlightProps {
  flight: FlightSearchResult;
  formattedFlightData: IFormatedFlightData;
}

interface FlightSelectItemProps extends CustomizedFlightProps {
  flightNumber: string;
  onSelectFlight: (selectedFlight: FlightSearchResult | null) => void;
}

export const CustomizedFlightLabel = ({
  flight,
  formattedFlightData,
}: CustomizedFlightProps) => {
  const {
    formattedDepartureTime,
    formattedArrivalTime,
    formattedFlightNumber,
  } = formattedFlightData;
  const { operatingAirlineCode, operatingAirlineName } = flight;
  return (
    <Box sx={{ display: "flex", alignItems: "center" }}>
      {operatingAirlineCode && (
        <AirlineIcon
          flightNumber={formattedFlightNumber}
          src={`images/icons/airlines/${operatingAirlineCode.toLowerCase()}.svg`}
        />
      )}
      <Box ml={1} sx={{ width: "calc(100% - 65px)" }}>
        <Box>
          <strong>
            {formattedDepartureTime} - {formattedArrivalTime}
          </strong>
          <Box display="flex">
            <Box
              sx={{
                textOverflow: "ellipsis",
                overflow: "hidden",
                whiteSpace: "nowrap",
              }}
            >
              {operatingAirlineName}
            </Box>
            <Box mx={0.5}>|</Box>
            <Box sx={{ whiteSpace: "nowrap" }}>{formattedFlightNumber}</Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

const FlightSelectItem = ({
  flight,
  flightNumber,
  onSelectFlight,
  formattedFlightData,
}: FlightSelectItemProps) => {
  return (
    <RadioButtonGroupItem
      key={flightNumber}
      value={flightNumber}
      labelStyles={{
        "&, & .MuiFormControlLabel-label": {
          width: "100%",
          height: 48,
        },
      }}
      onChange={() => onSelectFlight(flight)}
      label={
        <CustomizedFlightLabel
          key={flightNumber}
          flight={flight}
          formattedFlightData={formattedFlightData}
        />
      }
    />
  );
};

export default FlightSelectItem;
